<p-dialog header="{{'fs.res.project.Project.organizations.additionalOrg.header' | hisUi: organization.organization.text}}"
          [(visible)]="visibility"
          (onHide)="closeDialog()"
          [modal]="true"
          [blockScroll]="true">

    <div class="layoutBlock">
		<div class="columnFullWidth">
            <div class="infoMessage">
                {{ 'fs.res.project.Project.organizations.additionalOrg.infotext' | hisUi }}
            </div>
            <br>
            <his-plam>
                <input class="inputWidth100" #content hisDdKey="fs.res.project.Project.organizations.additionalOrg.information"
                       [(ngModel)]="information">
            </his-plam>
		</div>
	</div>
    

    <p-footer>
        <button (click)="saveDialog()"><span>{{ 'common.apply' | hisUi }}</span></button>
        <button (click)="closeDialog()"><span>{{ 'common.cancel' | hisUi }}</span></button>
    </p-footer>
</p-dialog>